import axios from 'axios'

// 鍔ㄦ€佽幏鍙?API 鍦板潃锛屽熀浜庡綋鍓嶈闂湴鍧€
const getDynamicBaseURL = () => {
  // 濡傛灉鐜鍙橀噺鎸囧畾浜?API 鍦板潃锛岀洿鎺ヤ娇鐢?
  if (process.env.VUE_APP_BASE_API) {
    return process.env.VUE_APP_BASE_API
  }

  if (process.env.NODE_ENV === 'development') {
    return '/index.php/api'
  }

  // 鍔ㄦ€佽幏鍙栧綋鍓嶉〉闈㈢殑鍗忚鍜屼富鏈哄悕
  const protocol = window.location.protocol
  const hostname = window.location.hostname

  // 鏋勯€?API 鍦板潃锛氫娇鐢ㄥ綋鍓嶉〉闈㈢殑鍗忚鍜屼富鏈哄悕锛屼笉甯︾鍙ｅ彿
  return `${protocol}//${hostname}/index.php/api`
}

const request = axios.create({
  // Development env: call backend directly.
  baseURL: getDynamicBaseURL(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function (data) {
    // 转换为表单格式
    if (data && typeof data === 'object') {
      return Object.keys(data)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
        .join('&')
    }
    return data
  }]
})

request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      // FastAdmin 浣跨敤 token 瀛楁锛屼篃鍏煎 Authorization: Bearer
      config.headers.token = token
      config.headers.Authorization = `Bearer ${token}`
      console.log('銆愯姹傛嫤鎴櫒銆戞坊鍔爐oken:', token)
    }
    return config
  },
  error => Promise.reject(error)
)

request.interceptors.response.use(
  response => {
    const res = response.data
    console.log('銆愬搷搴旀嫤鎴櫒銆戝搷搴旀暟鎹?', res)

    // 濡傛灉璇锋眰璁剧疆浜?skipErrorHandler锛岀洿鎺ヨ繑鍥炲師濮嬫暟鎹?
    if (response.config.skipErrorHandler) {
      console.log('銆愬搷搴旀嫤鎴櫒銆戣烦杩囬敊璇鐞嗭紝杩斿洖鍘熷鍝嶅簲')
      return res
    }

    // Standard envelope: { code, data, message/msg }
    if (res && typeof res.code !== 'undefined') {
      const code = Number(res.code)
      const isSuccess = code === 200 || code === 1

      if (!isSuccess) {
        const errMsg = res.message || res.msg || '璇锋眰澶辫触'
        console.error('銆愬搷搴旀嫤鎴櫒銆戣姹傚け璐?', errMsg)
        return Promise.reject(new Error(errMsg))
      }
      return res.data
    }

    // Raw data response
    return res
  },
  error => {
    console.error('銆愬搷搴旀嫤鎴櫒銆戣姹傞敊璇?', error.response || error)
    if (error.response && error.response.status === 401) {
      console.error('【响应拦截器】401未授权，token可能已过期')
    }
    return Promise.reject(error)
  }
)

export default request

